"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    React__default = _interopDefault(React),
    effectorReact = require("effector-react"),
    PropTypes = _interopDefault(require("prop-types")),
    core = require("@material-ui/core"),
    DeleteIcon = _interopDefault(require("@material-ui/icons/Delete")),
    effector = require("effector"),
    get = _interopDefault(require("lodash.get")),
    Paper = _interopDefault(require("@material-ui/core/Paper")),
    Table = _interopDefault(require("@material-ui/core/Table")),
    recompose = require("recompose"),
    Checkbox = _interopDefault(require("@material-ui/core/Checkbox")),
    TableBody = _interopDefault(require("@material-ui/core/TableBody")),
    TableCell = _interopDefault(require("@material-ui/core/TableCell")),
    TableRow = _interopDefault(require("@material-ui/core/TableRow")),
    fromRenderProps = _interopDefault(require("recompose/fromRenderProps")),
    TableFooter = _interopDefault(require("@material-ui/core/TableFooter")),
    TablePagination = _interopDefault(require("@material-ui/core/TablePagination")),
    withStyles = _interopDefault(require("@material-ui/core/styles/withStyles")),
    TableHead = _interopDefault(require("@material-ui/core/TableHead")),
    TableSortLabel = _interopDefault(require("@material-ui/core/TableSortLabel")),
    compose = _interopDefault(require("recompose/compose")),
    Grid = _interopDefault(require("@material-ui/core/Grid")),
    Toolbar = _interopDefault(require("@material-ui/core/Toolbar")),
    IconButton = _interopDefault(require("@material-ui/core/IconButton")),
    Tooltip = _interopDefault(require("@material-ui/core/Tooltip")),
    SearchIcon = _interopDefault(require("@material-ui/icons/Search")),
    FilterListIcon = _interopDefault(require("@material-ui/icons/FilterList")),
    toRenderProps = _interopDefault(require("recompose/toRenderProps")),
    withState = _interopDefault(require("recompose/withState")),
    Button = _interopDefault(require("@material-ui/core/Button")),
    MenuItem = _interopDefault(require("@material-ui/core/MenuItem")),
    Popover = _interopDefault(require("@material-ui/core/Popover")),
    TextField = _interopDefault(require("@material-ui/core/TextField")),
    Typography = _interopDefault(require("@material-ui/core/Typography")),
    CloseIcon = _interopDefault(require("@material-ui/icons/Close")),
    Chip = _interopDefault(require("@material-ui/core/Chip")),
    colorManipulator = require("@material-ui/core/styles/colorManipulator");

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var r = t[a];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}

function _defineProperty(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];

      for (var r in a) {
        Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectSpread(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = null != arguments[e] ? arguments[e] : {},
        r = Object.keys(a);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(a).filter(function (e) {
      return Object.getOwnPropertyDescriptor(a, e).enumerable;
    }))), r.forEach(function (e) {
      _defineProperty(t, e, a[e]);
    });
  }

  return t;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, a = new Array(e.length); t < e.length; t++) {
      a[t] = e[t];
    }

    return a;
  }
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var defaultToolbarSelectActions = function defaultToolbarSelectActions(e) {
  var t = e.selectedData,
      a = e.handleDelete;
  return React__default.createElement(core.IconButton, {
    onClick: function onClick() {
      a(t);
    }
  }, React__default.createElement(DeleteIcon, null));
},
    createColumns = function createColumns(e) {
  var t = effector.createStore(e),
      a = effector.createEvent();
  return t.on(a, function (e, t) {
    return t;
  }), {
    $columns: t,
    changeColumns: a
  };
},
    cache = new Map(),
    hasCachedResult = function hasCachedResult(e, t, r) {
  return e.every(function (e, t) {
    var a = r.has(e);
    return a && (r = r.get(e)), a;
  });
},
    getCachedResult = function getCachedResult(e, t, a) {
  return e.reduce(function (e, t) {
    return e.get(t);
  }, a);
},
    setCachedResult = function setCachedResult(e, t, a) {
  var o = t.apply(null, e);
  return e.reduce(function (e, t, a, r) {
    return e.has(t) ? e.get(t) : (l = a === r.length - 1 ? o : new Map(), e.set(t, l), l);
    var l;
  }, a), o;
},
    fillArgsByFnLength = function fillArgsByFnLength(a, e) {
  return new Array(e).fill(void 0).map(function (e, t) {
    return a[t];
  });
},
    cachedResult = function cachedResult(e, t, a) {
  return hasCachedResult(e, t, a) ? getCachedResult(e, t, a) : setCachedResult(e, t, a);
},
    memoizeByArgs = function memoizeByArgs(l) {
  var o = cache.get(l) || cache.set(l, new Map()) && cache.get(l);
  return function () {
    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
      t[a] = arguments[a];
    }

    var r = fillArgsByFnLength(t, l.length);
    return cachedResult(r, l, o);
  };
},
    pipe = function pipe() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
    t[a] = arguments[a];
  }

  return function (e) {
    return t.reduce(function (e, t) {
      return t(e);
    }, e);
  };
},
    sort = memoizeByArgs(function (a, r) {
  return memoizeByArgs(function (e) {
    return e.concat().sort(function (e, t) {
      return get(e, a) > get(t, a) ? "ASC" === r ? 1 : -1 : get(e, a) < get(t, a) ? "DESC" === r ? 1 : -1 : 0;
    });
  });
}),
    search = memoizeByArgs(function (a, r) {
  return memoizeByArgs(function (e) {
    return e.filter(function (t) {
      return r.some(function (e) {
        return !!e.searchable && (get(t, e.name) ? get(t, e.name).toString().includes(a) : !a);
      });
    });
  });
}),
    filter = memoizeByArgs(function (a, r) {
  return memoizeByArgs(function (e) {
    return e.filter(function (t) {
      return r.every(function (e) {
        return !e.filterable || !a[e.name] || get(t, e.name) === a[e.name];
      });
    });
  });
}),
    paginate = memoizeByArgs(function (t, a) {
  return memoizeByArgs(function (e) {
    return e.slice(t * a, t * a + a);
  });
}),
    convertDataToFilterLists = memoizeByArgs(function (e, t) {
  return t.reduce(function (t, a) {
    return a.filterable && (t[a.name] = {
      list: [],
      label: a.label
    }, e.forEach(function (e) {
      return !t[a.name].list.includes(get(e, a.name)) && t[a.name].list.push(get(e, a.name));
    }), t[a.name].list.sort()), t;
  }, {});
}),
    completeColumnsWithOptions = function completeColumnsWithOptions(e) {
  return e.map(function (e) {
    return _objectSpread({
      sortable: !0,
      filterable: !0,
      searchable: !0
    }, e);
  });
},
    createComputedData = function createComputedData(e, t, a, r, l) {
  return {
    $computedData: effector.combine(e, t, a, r, l, function (e, t, a, r, l) {
      return pipe(sort(a.columnName, a.direction), search(r, t), filter(l, t))(e);
    })
  };
},
    createData = function createData(e) {
  var t = effector.createStore(e),
      a = effector.createEvent(),
      r = effector.createEvent();
  return t.on(a, function (e, t) {
    return t;
  }).on(r, function (e, t) {
    return e.filter(function (e) {
      return !t.includes(e);
    });
  }), {
    $data: t,
    changeData: a,
    handleDelete: r
  };
},
    createDisplayData = function createDisplayData(e, t, a) {
  return {
    $displayData: effector.combine(e, t, a, function (e, t, a) {
      return paginate(t, a)(e);
    })
  };
},
    createFilterLists = function createFilterLists(e, t) {
  return {
    $filterLists: effector.combine(e, t, function (e, t) {
      return convertDataToFilterLists(e, t);
    })
  };
},
    createFilterValues = function createFilterValues(e) {
  var t = effector.createStore(e),
      a = effector.createEvent(),
      r = effector.createEvent(),
      l = effector.createEvent(),
      o = effector.createEvent();
  return t.on(r, function (e, t) {
    return _objectSpread({}, e, _defineProperty({}, t.columnName, t.value));
  }).on(l, function (a, e) {
    var r = e.columnName;
    return Object.keys(a).reduce(function (e, t) {
      return t !== r && (e[t] = a[t]), e;
    }, {});
  }).on(a, function (e, t) {
    return t;
  }).reset(o), {
    $filterValues: t,
    changeFilterValues: a,
    addFilter: r,
    removeFilter: l,
    resetFilter: o
  };
},
    createPage = function createPage(e) {
  var t = effector.createStore(e),
      a = effector.createEvent();
  return t.on(a, function (e, t) {
    return t;
  }), {
    $page: t,
    changePage: a
  };
},
    createPerPage = function createPerPage(e) {
  var t = effector.createStore(e),
      a = effector.createEvent();
  return t.on(a, function (e, t) {
    return t;
  }), {
    $perPage: t,
    changePerPage: a
  };
},
    createSearchValue = function createSearchValue(e, t) {
  var a = effector.createStore(e),
      r = effector.createEvent();
  return a.on(r, function (e, t) {
    return t;
  }).reset(t), {
    $searchValue: a,
    handleSearchValue: r
  };
},
    createSelectedData = function createSelectedData(e, t, a) {
  var r = effector.createStore(e),
      l = effector.createEvent(),
      o = effector.createEvent(),
      n = effector.createEvent();
  return r.on(n, function (e, t) {
    return t;
  }).on(l, function (e, t) {
    var a = _toConsumableArray(e),
        r = a.findIndex(function (e) {
      return e === t;
    });

    return -1 !== r ? a.splice(r, 1) : a.push(t), a;
  }).on(o, function (e) {
    return e.length ? [] : _toConsumableArray(t.getState());
  }).on(a, function (e, t) {
    return e.filter(function (e) {
      return !t.includes(e);
    });
  }), {
    $selectedData: r,
    toggleSelectRow: l,
    toggleSelectAll: o,
    handleSelect: n
  };
},
    createShowSearchBar = function createShowSearchBar(e) {
  var t = effector.createStore(e),
      a = effector.createEvent(),
      r = effector.createEvent();
  return t.on(r, function (e) {
    return !e;
  }).on(a, function (e, t) {
    return t;
  }), {
    $showSearchBar: t,
    changeShowSearchBar: a,
    toggleSearchBar: r
  };
},
    createSort = function createSort(e) {
  var t = effector.createStore(e),
      a = effector.createEvent();
  return t.on(a, function (e, t) {
    var a = t.columnName,
        r = t.direction;
    return {
      columnName: a,
      direction: void 0 === r ? "ASC" : r
    };
  }), {
    $sort: t,
    handleSort: a
  };
},
    createModel = function createModel(e) {
  var t = e.data,
      a = void 0 === t ? [] : t,
      r = e.columns,
      l = void 0 === r ? [] : r,
      o = e.showSearchBar,
      n = void 0 !== o && o,
      c = e.searchValue,
      i = void 0 === c ? "" : c,
      u = e.sort,
      s = void 0 === u ? {
    columnName: null,
    direction: "ASC"
  } : u,
      f = e.page,
      p = void 0 === f ? 0 : f,
      d = e.perPage,
      m = void 0 === d ? 5 : d,
      h = e.selectedData,
      b = void 0 === h ? [] : h,
      g = e.filterValues,
      _ = void 0 === g ? {} : g,
      R = createData(a),
      D = R.$data,
      P = R.changeData,
      y = R.handleDelete,
      S = createColumns(l),
      T = S.$columns,
      v = S.changeColumns,
      E = createSort(s),
      C = E.$sort,
      w = E.handleSort,
      I = createShowSearchBar(n),
      A = I.$showSearchBar,
      M = I.changeShowSearchBar,
      U = I.toggleSearchBar,
      B = createSearchValue(i, U),
      F = B.$searchValue,
      V = B.handleSearchValue,
      O = createSelectedData(b, D, y),
      $ = O.$selectedData,
      x = O.toggleSelectRow,
      q = O.toggleSelectAll,
      j = O.handleSelect,
      k = createFilterValues(_),
      L = k.$filterValues,
      z = k.changeFilterValues,
      N = k.addFilter,
      G = k.removeFilter,
      H = k.resetFilter,
      W = createPage(p),
      J = W.$page,
      K = W.changePage,
      Q = createPerPage(m),
      X = Q.$perPage,
      Y = Q.changePerPage,
      Z = createComputedData(D, T, C, F, L).$computedData,
      ee = createFilterLists(Z, T).$filterLists,
      te = createDisplayData(Z, J, X).$displayData,
      ae = effector.createStoreObject({
    data: D,
    columns: T,
    sort: C,
    filterValues: L,
    searchValue: F,
    showSearchBar: A,
    selectedData: $,
    page: J,
    perPage: X,
    computedData: Z,
    filterLists: ee,
    displayData: te
  });

  return {
    $store: ae,
    actions: {
      changeData: P,
      changeColumns: v,
      changeShowSearchBar: M,
      changeFilterValues: z,
      toggleSelectRow: x,
      toggleSelectAll: q,
      toggleSearchBar: U,
      handleSearchValue: V,
      handleSort: w,
      addFilter: N,
      removeFilter: G,
      resetFilter: H,
      changePage: K,
      changePerPage: Y,
      handleSelect: j,
      handleDelete: y
    },
    subscribe: function subscribe(e) {
      var s,
          f,
          t = (s = e, f = ae, function (u) {
        return function (e) {
          var t = f.getState(),
              a = t.searchValue,
              r = t.showSearchBar,
              l = t.sort,
              o = t.filterValues,
              n = t.page,
              c = t.perPage,
              i = t.selectedData;
          s({
            name: u,
            value: e,
            state: {
              searchValue: a,
              showSearchBar: r,
              sort: l,
              filterValues: o,
              page: n,
              perPage: c,
              selectedData: i
            }
          });
        };
      }),
          a = A.watch(t("showSearchBar")),
          r = J.watch(t("page")),
          l = X.watch(t("perPage")),
          o = $.watch(t("selectedData")),
          n = F.watch(t("searchValue")),
          c = C.watch(t("sort")),
          i = L.watch(t("filterValues"));
      return function () {
        a(), r(), l(), o(), n(), c(), i();
      };
    }
  };
},
    mapDatatableProps = function mapDatatableProps(e) {
  return {
    title: e.title,
    columns: e.columns,
    customCell: e.customCell,
    showSearchBar: e.showSearchBar,
    searchValue: e.searchValue,
    sort: e.sort,
    filterValues: e.filterValues,
    selectedData: e.selectedData,
    toolbarSelectActions: e.toolbarSelectActions,
    toolbarActions: e.toolbarActions,
    rowActions: e.rowActions,
    page: e.page,
    perPage: e.perPage,
    perPageOption: e.perPageOption,
    selectable: e.selectable,
    filterable: e.filterable,
    searchable: e.searchable,
    localization: e.localization
  };
},
    mapDatatableCalculatedProps = function mapDatatableCalculatedProps(e) {
  return {
    computedData: e.computedData,
    filterLists: e.filterLists,
    displayData: e.displayData
  };
},
    mapDatatableHandlers = function mapDatatableHandlers(e) {
  return {
    toggleSelectRow: e.toggleSelectRow,
    toggleSelectAll: e.toggleSelectAll,
    toggleSearchBar: e.toggleSearchBar,
    handleSearchValue: e.handleSearchValue,
    handleSort: e.handleSort,
    addFilter: e.addFilter,
    removeFilter: e.removeFilter,
    resetFilter: e.resetFilter,
    changePage: e.changePage,
    changePerPage: e.changePerPage,
    handleSelect: e.handleSelect,
    handleDelete: e.handleDelete
  };
},
    _createContext = React.createContext(),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer,
    ReactMUIDatatableConsumer = Consumer,
    ReactMUIDatatableProvider = function (e) {
  function n(e) {
    var t;
    _classCallCheck(this, n), t = _possibleConstructorReturn(this, _getPrototypeOf(n).call(this, e));
    var a = createModel({}),
        r = a.$store,
        l = a.actions,
        o = a.subscribe;
    return t._EffectorStore = effectorReact.createStoreConsumer(r), (t._actions = l).changeData(t.props.data), l.changeColumns(completeColumnsWithOptions(t.props.columns)), l.handleSort(t.props.sort), l.changeShowSearchBar(t.props.showSearchBar), l.changeFilterValues(t.props.filterValues), l.handleSearchValue(t.props.searchValue), l.handleSelect(t.props.selectedData), l.changePage(t.props.page), l.changePerPage(t.props.perPage), t._unsubscribe = t.props.onStateChanged && o(t.props.onStateChanged) || function () {}, t;
  }

  return _inherits(n, React__default.Component), _createClass(n, [{
    key: "componentWillUnmount",
    value: function value() {
      this._unsubscribe();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this._EffectorStore,
          a = this._actions;
      return React__default.createElement(e, null, function (e) {
        return React__default.createElement(Provider, {
          value: _objectSpread({}, mapDatatableProps(_objectSpread({}, t.props, e)), mapDatatableCalculatedProps(_objectSpread({}, e)), mapDatatableHandlers(_objectSpread({}, a)))
        }, t.props.children);
      });
    }
  }]), n;
}();

ReactMUIDatatableProvider.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  customCell: PropTypes.func,
  title: PropTypes.string.isRequired,
  showSearchBar: PropTypes.bool,
  searchValue: PropTypes.string,
  sort: PropTypes.shape({
    columnName: PropTypes.string,
    direction: PropTypes.oneOf.DESC
  }),
  toolbarSelectActions: PropTypes.func,
  toolbarActions: PropTypes.func,
  rowActions: PropTypes.func,
  page: PropTypes.number,
  perPage: PropTypes.number,
  perPageOption: PropTypes.arrayOf(PropTypes.number),
  selectedData: PropTypes.arrayOf(PropTypes.object),
  filterValues: PropTypes.object,
  selectable: PropTypes.bool,
  filterable: PropTypes.bool,
  searchable: PropTypes.bool,
  localization: PropTypes.shape({
    toolbar: PropTypes.shape({
      searchAction: PropTypes.string,
      filterAction: PropTypes.string,
      closeSearch: PropTypes.string
    }),
    filterLists: PropTypes.shape({
      title: PropTypes.string,
      allOption: PropTypes.string,
      reset: PropTypes.string
    }),
    toolbarSelect: PropTypes.shape({
      selectedData: PropTypes.func
    }),
    pagination: PropTypes.shape({
      rowsPerPage: PropTypes.string,
      displayedRows: PropTypes.func
    })
  }),
  onStateChanged: PropTypes.func
}, ReactMUIDatatableProvider.defaultProps = {
  data: [],
  columns: [],
  title: "",
  showSearchBar: !1,
  searchValue: "",
  sort: {
    columnName: null,
    direction: "ASC"
  },
  toolbarSelectActions: defaultToolbarSelectActions,
  page: 0,
  perPage: 5,
  perPageOption: [5, 10, 15],
  selectedData: [],
  filterValues: {},
  selectable: !0,
  filterable: !0,
  searchable: !0,
  localization: {
    toolbar: {
      searchAction: "Search",
      filterAction: "Filters",
      closeSearch: "Close search"
    },
    filterLists: {
      title: "Filter",
      allOption: "All",
      reset: "Reset"
    },
    toolbarSelect: {
      selectedData: function selectedData(e) {
        return "".concat(e, " row(s) selected");
      }
    },
    pagination: {
      rowsPerPage: "Rows per page",
      displayedRows: function displayedRows(e) {
        var t = e.from,
            a = e.to,
            r = e.count;
        return "".concat(t, "-").concat(a, " of ").concat(r);
      }
    }
  },
  onStateChanged: function onStateChanged() {}
};

var ReactDatatableBody = function ReactDatatableBody(l) {
  return React__default.createElement(TableBody, null, l.displayData.map(function (a, r) {
    return React__default.createElement(TableRow, {
      key: r
    }, l.selectable && React__default.createElement(TableCell, {
      padding: "checkbox"
    }, React__default.createElement(Checkbox, {
      checked: l.selectedData.includes(a),
      onChange: function onChange() {
        return l.toggleSelectRow(a);
      }
    })), l.columns.map(function (e, t) {
      return React__default.createElement(TableCell, {
        key: t
      }, l.customCell ? l.customCell({
        value: get(l.displayData[r], e.name),
        column: e,
        row: a
      }) : get(l.displayData[r], e.name));
    }), Boolean(l.rowActions) && React__default.createElement(TableCell, null, l.rowActions({
      row: a,
      rowIndex: r
    })));
  }));
},
    ReactMUIDatatableBody = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    displayData: t.displayData,
    columns: t.columns,
    customCell: t.customCell,
    selectable: t.selectable,
    toggleSelectRow: t.toggleSelectRow,
    selectedData: t.selectedData,
    rowActions: t.rowActions
  };
})(ReactDatatableBody),
    ReactMUIDatatableFooter = function ReactMUIDatatableFooter(a) {
  var e = Number(Boolean(a.selectable)) + Number(Boolean(a.rowActions));
  return React__default.createElement(TableFooter, null, React__default.createElement(TableRow, null, React__default.createElement(TablePagination, {
    rowsPerPageOptions: a.perPageOption,
    colSpan: a.columns.length + e,
    count: a.computedData.length,
    rowsPerPage: a.perPage,
    page: a.page,
    onChangePage: function onChangePage(e, t) {
      return a.changePage(t);
    },
    onChangeRowsPerPage: function onChangeRowsPerPage(e) {
      return a.changePerPage(Number(e.target.value));
    },
    labelDisplayedRows: a.labels.displayedRows,
    labelRowsPerPage: a.labels.rowsPerPage
  })));
},
    ReactMUIDatatableFooter$1 = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    page: t.page,
    perPage: t.perPage,
    perPageOption: t.perPageOption,
    computedData: t.computedData,
    changePage: t.changePage,
    changePerPage: t.changePerPage,
    columns: t.columns,
    selectable: t.selectable,
    labels: t.localization.pagination,
    rowActions: t.rowActions
  };
})(ReactMUIDatatableFooter),
    ReactMUIDatatableHeader = function ReactMUIDatatableHeader(a) {
  return React__default.createElement(TableHead, null, React__default.createElement(TableRow, null, a.selectable && React__default.createElement(TableCell, {
    padding: "checkbox"
  }, React__default.createElement(Checkbox, {
    indeterminate: 0 !== a.selectedData.length && a.selectedData.length < a.computedData.length,
    checked: a.selectedData.length === a.computedData.length,
    onChange: a.toggleSelectAll
  })), a.columns.map(function (e, t) {
    return React__default.createElement(TableCell, {
      key: t,
      className: a.classes.head,
      onClick: function onClick() {
        return e.sortable && a.handleSort({
          columnName: e.name,
          direction: a.sort.columnName === e.name && "ASC" === a.sort.direction ? "DESC" : "ASC"
        });
      }
    }, e.sortable && e.name === a.sort.columnName && React__default.createElement(TableSortLabel, {
      active: e.name === a.sort.columnName,
      direction: a.sort.direction.toLowerCase()
    }), e.label);
  }), Boolean(a.rowActions) && React__default.createElement(TableCell, {
    className: a.classes.head
  })));
},
    ReactMUIDatatableHeader$1 = compose(fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    columns: t.columns,
    sort: t.sort,
    handleSort: t.handleSort,
    selectable: t.selectable,
    selectedData: t.selectedData,
    computedData: t.computedData,
    toggleSelectAll: t.toggleSelectAll,
    rowActions: t.rowActions
  };
}), withStyles(function () {
  return {
    head: {
      cursor: "pointer"
    }
  };
}))(ReactMUIDatatableHeader),
    ReactMUIDatatableToolbarFilterPopover = function ReactMUIDatatableToolbarFilterPopover(a) {
  return React__default.createElement(Popover, {
    open: Boolean(a.anchorEl),
    anchorEl: a.anchorEl,
    onClose: function onClose() {
      a.updateAnchorEl(null);
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, React__default.createElement(Grid, {
    container: !0,
    spacing: 24,
    className: a.classes.root
  }, React__default.createElement(Grid, {
    item: !0,
    xs: 12
  }, React__default.createElement(Typography, {
    variant: "title"
  }, a.labels.title)), Object.keys(a.filterLists).map(function (t, e) {
    return React__default.createElement(Grid, {
      item: !0,
      xs: 6,
      key: e
    }, React__default.createElement(TextField, {
      select: !0,
      SelectProps: {
        displayEmpty: !0
      },
      InputLabelProps: {
        shrink: !0
      },
      value: a.filterValues[t] || "",
      label: a.filterLists[t].label,
      onChange: function onChange(e) {
        return a.addFilter({
          columnName: t,
          value: e.target.value
        });
      },
      fullWidth: !0
    }, React__default.createElement(MenuItem, {
      value: "",
      defaultChecked: !0
    }, a.labels.allOption), a.filterLists[t].list.map(function (e, t) {
      return React__default.createElement(MenuItem, {
        value: e,
        key: t
      }, e);
    })));
  }), React__default.createElement(Grid, {
    item: !0,
    xs: 12
  }, React__default.createElement(Button, {
    color: "primary",
    onClick: a.resetFilter,
    fullWidth: !0
  }, React__default.createElement(Typography, {
    variant: "subheading"
  }, a.labels.reset)))));
},
    ReactMUIDatatableToolbarFilterPopover$1 = compose(fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    filterLists: t.filterLists,
    filterValues: t.filterValues,
    addFilter: t.addFilter,
    resetFilter: t.resetFilter,
    columns: t.columns,
    labels: t.localization.filterLists
  };
}), withStyles(function (e) {
  return {
    root: {
      padding: 2 * e.spacing.unit
    }
  };
}))(ReactMUIDatatableToolbarFilterPopover),
    PopoverModel = toRenderProps(withState("anchorEl", "updateAnchorEl", null)),
    ReactMUIDatatableToolbarActionsFilterAction = function ReactMUIDatatableToolbarActionsFilterAction(t) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Tooltip, {
    title: t.labels.filterAction
  }, React__default.createElement(IconButton, {
    "aria-label": t.labels.filterAction,
    onClick: function onClick(e) {
      return t.updateAnchorEl(e.currentTarget);
    }
  }, React__default.createElement(FilterListIcon, null))), React__default.createElement(ReactMUIDatatableToolbarFilterPopover$1, {
    updateAnchorEl: t.updateAnchorEl,
    anchorEl: t.anchorEl
  }));
},
    ReactMUIDatatableToolbarActionsFilterAction$1 = recompose.compose(fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  return {
    labels: _extends({}, e).localization.toolbar
  };
}), fromRenderProps(PopoverModel, function (e) {
  return _objectSpread({}, _extends({}, e));
}))(ReactMUIDatatableToolbarActionsFilterAction),
    ReactMUIDatatableToolbarActions = function ReactMUIDatatableToolbarActions(e) {
  var t = e.data,
      a = e.computedData,
      r = e.displayData;
  return React__default.createElement(Grid, {
    item: !0
  }, e.searchable && React__default.createElement(Tooltip, {
    title: e.labels.searchAction
  }, React__default.createElement(IconButton, {
    "aria-label": e.labels.searchAction,
    onClick: e.toggleSearchBar
  }, React__default.createElement(SearchIcon, null))), e.filterable && React__default.createElement(ReactMUIDatatableToolbarActionsFilterAction$1, null), Boolean(e.toolbarActions) && e.toolbarActions({
    data: t,
    computedData: a,
    displayData: r
  }));
},
    ReactMUIDatatableToolbarActions$1 = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    toggleSearchBar: t.toggleSearchBar,
    labels: t.localization.toolbar,
    searchable: t.searchable,
    filterable: t.filterable,
    toolbarActions: t.toolbarActions,
    data: t.data,
    computedData: t.computedData,
    displayData: t.displayData
  };
})(ReactMUIDatatableToolbarActions),
    ReactMUIDatatableToolbarSearchBar = function ReactMUIDatatableToolbarSearchBar(t) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    item: !0,
    xs: !0
  }, React__default.createElement(TextField, {
    value: t.searchValue,
    onChange: function onChange(e) {
      return t.handleSearchValue(e.target.value);
    },
    fullWidth: !0
  })), React__default.createElement(Grid, {
    item: !0
  }, React__default.createElement(Tooltip, {
    title: t.labels.closeSearch
  }, React__default.createElement(IconButton, {
    "aria-label": t.labels.closeSearch,
    onClick: t.toggleSearchBar
  }, React__default.createElement(CloseIcon, null)))));
},
    ReactMUIDatatableToolbarSearchBar$1 = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    searchValue: t.searchValue,
    handleSearchValue: t.handleSearchValue,
    toggleSearchBar: t.toggleSearchBar,
    labels: t.localization.toolbar
  };
})(ReactMUIDatatableToolbarSearchBar),
    ReactMUIDatatableToolbarTitle = function ReactMUIDatatableToolbarTitle(e) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    item: !0,
    style: {
      alignSelf: "center"
    }
  }, React__default.createElement(Typography, {
    variant: "title"
  }, e.title)), React__default.createElement(Grid, {
    item: !0,
    xs: !0
  }));
},
    ReactMUIDatatableToolbarTitle$1 = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  return {
    title: _extends({}, e).title
  };
})(ReactMUIDatatableToolbarTitle),
    ReactMUIDatatableToolbar = function ReactMUIDatatableToolbar(e) {
  return React__default.createElement(Toolbar, null, React__default.createElement(Grid, {
    container: !0
  }, e.showSearchBar ? React__default.createElement(ReactMUIDatatableToolbarSearchBar$1, null) : React__default.createElement(ReactMUIDatatableToolbarTitle$1, null), React__default.createElement(ReactMUIDatatableToolbarActions$1, null)));
},
    ReactMUIDatatableToolbar$1 = fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  return {
    showSearchBar: _extends({}, e).showSearchBar
  };
})(ReactMUIDatatableToolbar),
    ReactMUIDatatableToolbarFilterValues = function ReactMUIDatatableToolbarFilterValues(a) {
  return React__default.createElement(Grid, {
    container: !0,
    className: a.classes.root,
    spacing: 8
  }, Object.keys(a.filterValues).map(function (e, t) {
    return a.filterValues[e] && React__default.createElement(Grid, {
      item: !0,
      key: t
    }, React__default.createElement(Chip, {
      label: a.filterValues[e],
      onDelete: function onDelete() {
        return a.removeFilter({
          columnName: e
        });
      }
    }));
  }));
},
    ReactMUIDatatableToolbarFilterValues$1 = compose(fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    filterValues: t.filterValues,
    removeFilter: t.removeFilter
  };
}), withStyles(function (e) {
  return {
    root: {
      paddingLeft: 2 * e.spacing.unit,
      paddingTop: 2 * e.spacing.unit
    }
  };
}))(ReactMUIDatatableToolbarFilterValues),
    ReactMUIDatatableToolbarSelect = function ReactMUIDatatableToolbarSelect(e) {
  return React__default.createElement(Toolbar, {
    className: "".concat(e.classes.root, " ").concat(e.classes.highlight)
  }, React__default.createElement(Grid, {
    container: !0,
    justify: "space-between"
  }, React__default.createElement(Grid, {
    item: !0,
    className: e.classes.selected
  }, React__default.createElement(Typography, {
    color: "inherit",
    variant: "subheading"
  }, e.labels.selectedData(e.selectedData.length))), React__default.createElement(Grid, {
    item: !0
  }, e.toolbarSelectActions({
    data: e.computedData,
    selectedData: e.selectedData,
    updateSelectedData: e.handleSelect,
    handleDelete: e.handleDelete
  }))));
},
    ReactMUIDatatableToolbarSelect$1 = compose(fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  var t = _extends({}, e);

  return {
    handleSelect: t.handleSelect,
    handleDelete: t.handleDelete,
    selectedData: t.selectedData,
    toolbarSelectActions: t.toolbarSelectActions,
    computedData: t.computedData,
    labels: t.localization.toolbarSelect
  };
}), withStyles(function (e) {
  return {
    root: {
      borderRadius: "".concat(e.shape.borderRadius, "px ").concat(e.shape.borderRadius, "px 0 0")
    },
    highlight: {
      backgroundColor: colorManipulator.lighten(e.palette.secondary.light, .85),
      color: e.palette.secondary.main
    },
    selected: {
      alignSelf: "center"
    }
  };
}))(ReactMUIDatatableToolbarSelect),
    ReactMUIDatatableRoot = function ReactMUIDatatableRoot(e) {
  return React__default.createElement(Paper, null, e.selectedData.length ? React__default.createElement(ReactMUIDatatableToolbarSelect$1, null) : React__default.createElement(ReactMUIDatatableToolbar$1, null), React__default.createElement(ReactMUIDatatableToolbarFilterValues$1, null), React__default.createElement(Table, null, React__default.createElement(ReactMUIDatatableHeader$1, null), React__default.createElement(ReactMUIDatatableBody, null), React__default.createElement(ReactMUIDatatableFooter$1, null)));
},
    ReactMUIDatatableRoot$1 = recompose.fromRenderProps(ReactMUIDatatableConsumer, function (e) {
  return {
    selectedData: _extends({}, e).selectedData
  };
})(ReactMUIDatatableRoot),
    ReactMUIDatatable = function ReactMUIDatatable(e) {
  return React__default.createElement(ReactMUIDatatableProvider, e, React__default.createElement(ReactMUIDatatableRoot$1, null));
};

exports.ReactMUIDatatable = ReactMUIDatatable, exports.ReactMUIDatatableRoot = ReactMUIDatatableRoot$1, exports.ReactMUIDatatableProvider = ReactMUIDatatableProvider;